import React, { Component, memo } from "react";
import axios from "../../utils/axios";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import makeSelectGlobal from "../../redux/redux/global/selectors";
import makeSelectAccess from "../../redux/redux/access/selectors";
import { searchArchive, searchArchiveReset, setArchive, setArchiveCount, setPageNo} from "../../redux/redux/archiveJob/action";
import makeSelectArchive from "../../redux/redux/archiveJob/selectors";
import { percentAsPerStatus } from "../../utils/percAsPerStatus";
import { CATCH_TOAST, CLIENT_ADDED_ERROR, DAYS, NOT_APPLICABLE, NOT_APPLICABLE_DATE, OVERDUE } from "../../utils/labelContant";
import { getCusLocalDateYear } from "../../utils/localTime";
import * as qs from "query-string";
import { toast } from "react-toastify";

export default function ArchiveHoc(ComposedComponent) {
  class HOC extends Component {
    state = {
        loading: true,
        job_type: [],
        jobStatus: [],
        job_Manager:[],
    };

    getJobType = () => {
        axios
          .get("/dds/jobTypes")
          .then((res) => {
            let data = [...res.data.result];
            data = data.map((item) => {
              item = {
                key: `${item.id}_${item.job_name}`,
                value: item.id,
                text: item.job_name,
              };
              return item;
            });
              this.setState((prevState) => ({
                ...prevState,
                job_type: [...data],
              }))
          })
          .catch((e) => { })
          .finally(() => { });
    };

    getStatus = () => {
        axios
          .get("/dds/status")
          .then((res) => {
            let data = [...res.data.result.rows];
            data = data.map((item) => {
              item = {
                key: `${item.id}_${item.company_name}`,
                value: item.id,
                text: item.status,
              };
              return item;
            });
            this.setState((prevState) => ({
                ...prevState,
                jobStatus: [...data],
              }))
          })
          .catch((e) => { })
          .finally(() => { });
      };

    getManagers = () => {
        axios
          .get("/dds/managers")
          .then((res) => {
            let data = [...res.data.result];
            data = data.map((item) => {
              item = {
                key: `${item.id}_${item.employee_name}`,
                value: item.id,
                text: item.employee_name,
              };
              return item;
            });
            this.setState((prevState) => ({
                ...prevState,
                job_Manager: [...data],
              }))
          })
          .catch((e) => { })
          .finally(() => { });
    }; 
    onSelect = (value, type) => {
      this.props.dispatch(searchArchive(type, value));
    };
    resetSearch = () => {
      this.props.dispatch(searchArchiveReset());
    };
    getData = (paramObj={}) => {
      axios
        .get(`jobs/fetchArchiveJob`, {
          params: {
            ...paramObj,
            offset: this.props.archive.pageNumber * 10 - 10,
            limit: 10,
          },
        })
        .then(async (res) => {
          let data = res?.data?.result[0]?.rows;
          let row = res?.data?.result[0]?.count;
          data = data.map((item) => {
            let newVal = {
              ...item,

              id: item?.id || "N/A",
              reference_no: item?.reference_no || "N/A",
              company: item?.jobSowDoc?.company_name || "",
              client: item?.Company?.company_name || "",
              job_status_perc: (item.job_status_perc = (
                <div className="outerProgress">
                  <div className="inner">
                    <span
                      className="color"
                      style={{
                        width: `${percentAsPerStatus(item?.Status?.status)}`,
                      }}
                    ></span>
                    <span className="label">
                      {percentAsPerStatus(item?.Status?.status)}
                    </span>
                  </div>
                </div>
              )),
              job_type: item?.Job_type?.job_name || NOT_APPLICABLE,
              yearend_date:
                item?.jobSowDoc?.year_end_date === NOT_APPLICABLE_DATE
                  ? NOT_APPLICABLE
                  : getCusLocalDateYear(item?.jobSowDoc?.year_end_date),
              job_status: item?.Status?.status,
              createdBy: item?.createdByName || "",
              budget: item?.overall_budget_hours || "",
              actual: item?.overall_actual_hours || "",
              CREATE_BY: item?.createdByName || "",
              job_start_date:
                item?.job_start_date === NOT_APPLICABLE_DATE
                  ? NOT_APPLICABLE
                  : getCusLocalDateYear(item?.job_start_date),
              job_end_date:
                item?.job_end_date === NOT_APPLICABLE_DATE
                  ? NOT_APPLICABLE
                  : getCusLocalDateYear(item?.job_end_date),
              dispatchDate:
                item?.dispatch_date === NOT_APPLICABLE_DATE
                  ? NOT_APPLICABLE
                  : getCusLocalDateYear(item?.dispatch_date),
              days_left:
              item.days_left = item?.dispatch_date ? "" : (item?.daysLeft == null ? "" : (item.daysLeft == -1 ? OVERDUE : `${item.daysLeft} Days`)),
              manager: item?.Manager?.employee_name,
            };
            return newVal;
          });
          this.props.dispatch(setArchive(data)); 
          this.props.dispatch(setArchiveCount(row));
        })
        .catch((error) => {toast.error(CATCH_TOAST, {
          toastId: CLIENT_ADDED_ERROR,
        });})
    };
    setPageNumber = async (pageNumber) => {
      const query = await qs.stringify({ p: pageNumber });
      await this.props.dispatch(setPageNo(pageNumber));
      await this.props.history.push(this.props.location.pathname + `?${query}`);
    };

    componentDidMount() {
      setTimeout(() => {
        this.setState({ loading: false });
      }, 1000);
      this.getJobType();
      this.getStatus();
      this.getManagers();
      }
    
    render() {
      return <ComposedComponent
      {...this.props}
      job_type={this.state.job_type}
      job_Manager={this.state.job_Manager}
      jobStatus={this.state.jobStatus}
      onSelect={this.onSelect}
      resetSearch={this.resetSearch}
      getData={this.getData}
      setPageNumber={this.setPageNumber}
  />
    }
  }
  const mapStateToProps = createStructuredSelector({
    archive:makeSelectArchive(),
    global: makeSelectGlobal(),
    access: makeSelectAccess(),
  });

  function mapDispatchToProps(dispatch) {
    return {
      dispatch,
    };
  }

  const withConnect = connect(mapStateToProps, mapDispatchToProps);

  return compose(withConnect, memo)(HOC);
}
